module.exports = __webpack_public_path__ + "static/media/metalab-guide@2x.78100cfa.png";